export default __webpack_public_path__ + "static/media/close-modal.e17c9d79.svg";